module.exports = __webpack_public_path__ + "static/media/2-244.f85bebf6.png";